<script setup lang="ts">
import type { UiCarouselItem } from '@mop/cms/types';

defineOptions({
  name: 'UiCarousel',
});

defineProps({
  items: {
    type: Array as PropType<UiCarouselItem[]>,
    required: true,
  },
  textColor: {
    type: String,
    default: null,
  },
  backgroundColor: {
    type: String,
    default: null,
  },
});

const pausedClassRef = ref('');
</script>

<template>
  <div v-if="items.length" :style="{ '--color': textColor, backgroundColor: backgroundColor }" class="ui-mop-carousel">
    <div :class="['ui-mop-carousel__loop', pausedClassRef]">
      <div v-for="n in 3" :key="n" class="ui-mop-carousel__item-wrapper">
        <span
          v-for="(item, i) in items"
          :key="`item-${n}-${i}`"
          :class="['ui-mop-carousel__item', item.type ? `ui-mop-carousel__item--${item.type}` : '']"
        >
          {{ item.text }}
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes leftTransition {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
}

.ui-mop-carousel {
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
}

.ui-mop-carousel__loop {
  display: flex;
  flex-flow: row nowrap;
}

.ui-mop-carousel__item-wrapper {
  will-change: transform;
  animation-duration: 18s;
  animation-name: leftTransition;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-timing-function: linear;
}

.ui-mop-carousel__loop--paused {
  .ui-mop-carousel__item-wrapper {
    animation-play-state: paused;
  }
}

.ui-mop-carousel__item {
  padding-right: $space30;
}
</style>
